// Machine-authored for Phase 8; requires review by a native Arabic speaker.
const catalog = {
  moduleTitle: "الأنظمة",
  actions: {
    update: "تعديل سعر البيع",
  },
  permissions: {
    core: "النواة",
    moduleManagement: "إدارة الأنظمة",
    modules: "الأنظمة",
  },
  listTitle: "الأنظمة",
  listSubtitle: "استعراض الأنظمة القابلة للبيع وإدارة سعر بيعها",
  filters: {
    search: "البحث في الأنظمة",
    searchPlaceholder: "ابحث بالاسم",
  },
  table: {
    module: "النظام",
    purchasingPrice: "سعر الشراء",
    sellingPrice: "سعر البيع",
    actions: "الإجراءات",
    empty: "لا توجد أنظمة مطابقة لهذه التصفية.",
    error: "تعذر تحميل الأنظمة.",
    loading: "جارٍ تحميل الأنظمة",
    showingCount: "عرض {{count}} من {{total}}",
    rowsPerPageLabel: "عرض الصفوف",
    nextPage: "الصفحة التالية",
    previousPage: "الصفحة السابقة",
    pagination: "ترقيم الصفحات",
    sortAscending: "ترتيب تصاعدي",
    sortDescending: "ترتيب تنازلي",
  },
  actionMenu: {
    trigger: "إجراءات النظام",
  },
  editDialog: {
    title: "تعديل سعر البيع",
    description: "تحديث سعر بيع {{name}}.",
    moduleName: "النظام",
    purchasingPrice: "سعر الشراء",
    purchasingPriceHint: "سعر ثابت من الكتالوج، ولا يمكن تعديله هنا.",
    sellingPrice: "سعر البيع",
    save: "حفظ التعديلات",
    cancel: "إلغاء",
    close: "إغلاق نافذة تعديل سعر البيع",
  },
  validation: {
    sellingPriceRequired: "سعر البيع مطلوب.",
    sellingPriceInvalid: "يرجى إدخال سعر بيع صحيح غير سالب.",
  },
};

export default catalog;
